module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/form_diagram_en-9ee045f4e793da5e1cff3ef11136335f.png";